import React from "react";

import Image from "next/image";
import { cn } from "@/lib/utils";

import { GROQImage } from "@/sanity/lib/definitions";

/**
 * Framed photo with the small mono caption tucked under its bottom-right corner.
 * Shared by the hero portrait and the timeline entries — they differ only in size,
 * aspect ratio and caption scale, which callers pass in.
 */
export default function PhotoCard({
  image,
  caption,
  aspect = "aspect-[763/741]",
  priority = false,
  className,
  frameClassName,
  captionClassName,
}: {
  image?: GROQImage;
  caption?: string;
  aspect?: string;
  priority?: boolean;
  className?: string;
  /** the padded box around the photo — the mobile frames are drawn much tighter */
  frameClassName?: string;
  captionClassName?: string;
}) {
  if (!image?.src) return null;

  return (
    <div className={cn("flex flex-col items-end gap-[0.65rem]", className)}>
      <div
        className={cn(
          "w-full rounded-[1rem] border-[0.11rem] border-[#112628]/[.65] p-[.5rem] lg:p-[0.9rem]",
          frameClassName,
        )}>
        <div className={cn("relative w-full overflow-hidden rounded-[0.75rem]", aspect)}>
          <Image
            className="absolute top-0 left-0 !h-full !w-full object-cover object-[50%_35%]"
            src={image}
            alt={caption || ""}
            priority={priority}
            quality={100}
          />
        </div>
      </div>

      {caption && (
        <p
          className={cn(
            "m-0 rounded-[0.45rem] bg-[#112628]/[.15] px-[0.75rem] py-[0.5rem] font-geistmono text-[2rem] leading-none text-black uppercase",
            captionClassName,
          )}>
          {caption}
        </p>
      )}
    </div>
  );
}
